import type { FaireProductEntity } from "../../entity_types/product";

export const p_ms2m8wbe5s: FaireProductEntity = {
  token: "p_ms2m8wbe5s",
  type: "product",
  name: "Women's Ultra Soft Ribbed Shawl Wrap - One Size",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/92e20b1834944bc462ff499232b412e04ed8c10df06739e848c580a2d537726f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/782181908d243e1646e7037840ed143c65eebc93ad56d5391a1acfa3be28e385.jpeg",
    "https://cdn.faire.com/fastly/48f5a9f6afe6c3eb1585ff50e32f10b8cd7fbc76950d17f9c90ce37846e935b6.jpeg",
    "https://cdn.faire.com/fastly/5168adad75279d68f19b19813a2e965e92126f1f1bb76e2dab0ca131892c671f.png",
    "https://cdn.faire.com/fastly/88841fcbed06efc0d7c04cc05ceb93ff92729c7ca83e3484e6258085ff1aa602.jpeg",
    "https://cdn.faire.com/fastly/a29e949d07fe88b9dc7aaf26ad9f05808dbe60c3263b6f08e06a674f8c515c1d.jpeg",
    "https://cdn.faire.com/fastly/0b2d757985ca9a1d1e3367ffb0581d054fb7ced39aa0f9e26bd88f4342ef45e3.jpeg",
    "https://cdn.faire.com/fastly/47f2518dd68cf520a799232eff2210752b6a7b744e054508c222c0fc0120d40d.png",
    "https://cdn.faire.com/fastly/3d36cc83399592946bd9415b2890d8add999e17079155e560369c80afc747e45.jpeg",
    "https://cdn.faire.com/fastly/94e95cab145a81bfbcb6214b00cef988222e6da047cc4246d11ff4abb4a5a5d4.jpeg",
    "https://cdn.faire.com/fastly/3309ee590febed9c4a185c429a852c637eb05049fb46b7b47957fcc706d3b247.jpeg",
    "https://cdn.faire.com/fastly/a4d4a7c13494dcddae24059aea110b0b17a1c97d2710df27cb42066cca4fe5ef.png",
    "https://cdn.faire.com/fastly/6edafce836dc83441ae1c883bf8cdad8aba87a5eead3b19f656b4150c13987cb.jpeg",
    "https://cdn.faire.com/fastly/ad74c5ed56e4888028967d20c2d1df86abf0d8f4fa9727004dce0e48346758a2.jpeg",
    "https://cdn.faire.com/fastly/489b08172d214f750907c22205e8606a75130de24f7e416ea60c2803a2aec5e4.jpeg",
    "https://cdn.faire.com/fastly/c822c507b183398bbfff210799692b27a1bdeda59876c88c7d454ba3179a7e7b.png"
  ],
  priceDollars: 55,
  description: "A timeless layer can make even the quietest moments feel a little more special. Thoughtfully designed to drape beautifully and feel incredibly inviting. \n\nFabrication:\nMade from Softies' signature Marshmallow fabric, this shawl delivers the ultra-plush softness that has made it a longtime favorite.\n\nFeatures:\n● Shawl silhouette drapes effortlessly for versatile styling\n● Ribbed texture adds a refined, elevated touch\n● Open-front design makes layering easy and comfortable\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Layering on cool mornings and evenings\n● Relaxing at home in comfort\n● Thoughtful gifting for any occasion",
  tags: [],
  msrpDollars: 119,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:05.201Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
